import React from 'react'
import Dashboard from '../sections/about/Dashboard'
import Advertisement from '../sections/about/Advertisement'
import Client from '../sections/about/Client'
import Footer from '../layout/footer'
import Reviews from '../sections/review/Reviews'
import { Helmet } from 'react-helmet'

const About = () => {
  return (
    <div id='page'>
      <Helmet>
        <title> Vwrap | About Us</title>
        <meta name="description" content="Learn about us and how we operate through the Vwrap website. Our services are curated to fit each client’s needs and yield a successful marketing result!" />
      </Helmet>
      <Dashboard />
       <Advertisement />
       <Reviews />
       <Footer />
    </div>
  )
}

export default About
